/**
 * freshFileUrls — s99 D477 (Build 61 TestFlight, 2026-10-11: an uploaded photo on Detect showed
 * a "?" and "Tap to view" did nothing).
 *
 * ★ A STORED FILE IS A PATH; THE LINK TO IT LASTS ONE HOUR. The API signs every stored path on
 *   read (deep_resolve_file_paths, storage_get_signed_url expires_in=3600), so a case held in
 *   the app's store for longer than that renders dead links. The report came from an app that
 *   had been open 12.7 hours. The cure is a fresh read of the case, merged by file id: only the
 *   link fields move, everything the patient did locally (new files, removals) stays.
 */
const LINK_KEYS = ['url', 'storageUrl', 'storagePath']

export function mergeFreshUrls(local, fresh) {
  if (!Array.isArray(local) || !local.length || !Array.isArray(fresh) || !fresh.length) return local
  const byId = new Map(fresh.filter((f) => f && f.id != null).map((f) => [String(f.id), f]))
  let changed = false
  const out = local.map((item) => {
    const f = item && item.id != null ? byId.get(String(item.id)) : null
    if (!f) return item
    const next = { ...item }
    for (const k of LINK_KEYS) {
      if (typeof f[k] === 'string' && f[k] && f[k] !== item[k]) { next[k] = f[k]; changed = true }
    }
    return next
  })
  return changed ? out : local
}

/** The detect lists of a raw GET /cases/<id> answer, in the store's own mapping (stores/index.js). */
export function detectListsOf(c) {
  if (!c) return null
  return {
    photos: (c.detect && c.detect.photos) || c.photos || [],
    videos: (c.detect && c.detect.videos) || c.videos || [],
    documents: (c.detect && c.detect.documents) || [],
  }
}
